export const ENV = {
  PRODUCT_API_ENDPOINT: import.meta.env.VITE_PRODUCT_API_ENDPOINT || "",
  AUTH_PORTAL_URL: import.meta.env.VITE_AUTH_PORTAL_URL || "",
  PRODUCT_ID: import.meta.env.VITE_PRODUCT_ID || "survey",
  COGNITO_USERPOOL_ID: import.meta.env.VITE_COGNITO_USERPOOL_ID || "",
  CLIENT_ID: import.meta.env.VITE_COGNITO_CLIENT_ID || "",
  ENV: import.meta.env.VITE_ENV || "dev",
  // PRODUCT_DEV-838: 配信ホストでテナントが決まる環境（専用テナント）だけ非空。
  // 無印は空のまま（空だとテナントを固定しない）。
  FIXED_TENANT_ID: import.meta.env.VITE_FIXED_TENANT_ID || "",
};

// 本番判定の集約点。dev/stg/feat-* は非 prod。
export const IS_PROD = ENV.ENV === "prod";
